import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBatteryFull"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5V19H20V16H23V8H20V5H1ZM20 10V14H21V10H20ZM5 9H7V15H5V9ZM11.5 15V9H9.5V15H11.5ZM14 9H16V15H14V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryFull;
